import { render, staticRenderFns } from "./SentOrdersTable.vue?vue&type=template&id=14950490&scoped=true&"
import script from "./SentOrdersTable.vue?vue&type=script&lang=js&"
export * from "./SentOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./SentOrdersTable.vue?vue&type=style&index=0&id=14950490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14950490",
  null
  
)

export default component.exports